import { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Private_Routes } from '../constants';
import UserMenu from './UserMenu';
import { AppBarMenu } from './menu';
import { AppContext } from '../context/Provider';
import { SelectLanguage } from '../../ui/shared/select-languages';

export default function Header() {
    const { isSkinSmart, langResources } = useContext(AppContext);

    useEffect(() => {
        var verticalOverlay = document.getElementsByClassName('vertical-overlay');
        if (verticalOverlay) {
            verticalOverlay[0].addEventListener('click', function () {
                document.body.classList.remove('vertical-sidebar-enable');
            });
        }
    });

    const toogleMenuBtn = () => {
        var windowSize = document.documentElement.clientWidth;
        var scrollbar = document.getElementById('scrollbar');
        var navbar = document.getElementById('navbar-nav');

        if (windowSize > 767)
            document.querySelector('.hamburger-icon')?.classList.toggle('open');

        //For collapse vertical menu
        if (document.documentElement.getAttribute('data-layout') === 'vertical') {
            if (windowSize < 1025 && windowSize > 767) {
                document.body.classList.remove('vertical-sidebar-enable');
                if (
                    document.documentElement.getAttribute('data-sidebar-size') ===
                    'sm'
                ) {
                    document.documentElement.setAttribute('data-sidebar-size', '');
                } else {
                    document.documentElement.setAttribute('data-sidebar-size', 'sm');
                }
            } else if (windowSize > 1025) {
                document.body.classList.remove('vertical-sidebar-enable');
                document.documentElement.getAttribute('data-sidebar-size') === 'lg'
                    ? document.documentElement.setAttribute(
                          'data-sidebar-size',
                          'sm'
                      )
                    : document.documentElement.setAttribute(
                          'data-sidebar-size',
                          'lg'
                      );
            } else if (windowSize <= 767) {
                document.body.classList.add('vertical-sidebar-enable');
                document.documentElement.setAttribute('data-sidebar-size', 'lg');
            }

            scrollbar?.classList.toggle('scrollbar');
        }
    };

    return (
        <>
            <header id='page-topbar' style={{ height: 60 }}>
                <div className='layout-width'>
                    {!isSkinSmart && (
                        <ul className='background'>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                        </ul>
                    )}

                    <div className='navbar-header' style={{ height: 60 }}>
                        <div className='d-flex'>
                            <div className='navbar-brand-box horizontal-logo'>
                                <a href='/' className='logo logo-dark'>
                                    <span className='logo-sm'>
                                        <img
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                            }}
                                            src='/assets/images/logo-sm.png'
                                            alt=''
                                        />
                                    </span>
                                    <span className='logo-lg'>
                                        <img
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                            }}
                                            src='/assets/images/logo-dark.png'
                                            alt=''
                                        />
                                    </span>
                                </a>

                                <a href='/' className='logo logo-light'>
                                    <span className='logo-sm'>
                                        <img
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                            }}
                                            src='/assets/images/logo-sm.png'
                                            alt=''
                                        />
                                    </span>
                                    <span className='logo-lg'>
                                        <img
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                            }}
                                            src='/assets/images/logo-light.png'
                                            alt=''
                                        />
                                    </span>
                                </a>
                            </div>

                            <button
                                onClick={toogleMenuBtn}
                                type='button'
                                className='btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger'
                                id='topnav-hamburger-icon'
                            >
                                <span className='hamburger-icon'>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </button>
                        </div>

                        <div className='d-flex align-items-center'>
                            <SelectLanguage />

                            <UserMenu></UserMenu>
                        </div>
                    </div>
                </div>
            </header>
            <AppBarMenu />
        </>
    );
}
